/**
 * Spinner de carga
 */

import { cva } from 'class-variance-authority';
import { cn } from '../../../utils';

interface SpinnerProps {
    size?: 'small' | 'default' | 'large';
    className?: string;
}

const spinnerVariants = cva(
    'animate-spin rounded-full border-solid border-border border-t-primary',
    {
        variants: {
            size: {
                small: 'h-4 w-4 border-2',
                default: 'h-8 w-8 border-[3px]',
                large: 'h-12 w-12 border-4',
            },
        },
        defaultVariants: {
            size: 'default',
        },
    }
);

export function Spinner({ size = 'default', className = '' }: SpinnerProps) {
    return (
        <div
            className={cn(spinnerVariants({ size }), className)}
            role="status"
            aria-label="Cargando"
        >
            <span className="sr-only">Cargando...</span>
        </div>
    );
}
